import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-calendar-header",
  templateUrl: "./calendar-header.component.html"
})
export class CalendarHeaderComponent {
  @Input() view: string;

  @Input() viewDate: Date;

  @Input() locale: string = "en";

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();

  constructor() {}
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/calendar-utils/calendar-header.component.ts